import { render, staticRenderFns } from "./affirmTwo.vue?vue&type=template&id=a5e5e120&scoped=true"
import script from "./affirmTwo.vue?vue&type=script&lang=js"
export * from "./affirmTwo.vue?vue&type=script&lang=js"
import style0 from "./affirmTwo.vue?vue&type=style&index=0&id=a5e5e120&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5e5e120",
  null
  
)

export default component.exports